import { render, staticRenderFns } from "./ListActivity.vue?vue&type=template&id=64f23588&"
import script from "./ListActivity.vue?vue&type=script&lang=js&"
export * from "./ListActivity.vue?vue&type=script&lang=js&"
import style0 from "./ListActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports